import React from 'react';
import { useSelector } from 'react-redux';
import { Layout, Modal, Paragraph, Spinner } from '@vwfs-bronson/bronson-react';
import { t } from 'i18next';
import { loadingSelectors } from '../../../services/redux/features/loading.slice';

interface PopupProps {
  shown: boolean;
  onClose: () => any;
  onConfirm: () => any;
  text: string;
}

export const CopyQuoteModal = ({ shown, onClose, onConfirm, text }: PopupProps) => {
  const isLoading = useSelector(loadingSelectors.selectLoading);
  return (
    <Modal
      title={t('app:dashboardActionModalTitle')}
      hideTitle
      buttonConfirmLabel={t('step3:copyModal:confirm')}
      buttonConfirmText={t('step3:copyModal:confirm')}
      buttonCancelLabel={t('step3:copyModal:cancel')}
      buttonCancelText={t('step3:copyModal:cancel')}
      id="copyQuote"
      onConfirm={onConfirm}
      onCancel={onClose}
      onClickOutside={onClose}
      onClose={onClose}
      shown={shown}
      asPortal
      center
    >
      {isLoading ? (
        <Layout>
          <Layout.Item className="u-mv text-center">
            <Spinner center />
          </Layout.Item>
        </Layout>
      ) : (
        <Paragraph className="u-mv u-text-center">{text}</Paragraph>
      )}
    </Modal>
  );
};
